import { c as _c } from "react/compiler-runtime";
import useChatMessageStore from '@module/stores/useChatMessageStore';
import type { EventAnimCoinMessage } from '@module/types/centrifuge/public-message/eventMessageTypes';
import BaseLottie from '@pc/components/lottie/BaseLottie';
import { useEffect, useRef, useState } from 'react';
function ChatEventLottie() {
  const $ = _c(12);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const queueRef = useRef(t0);
  const timerRef = useRef(null);
  const [currentContent, setCurrentContent] = useState(null);
  let enqueue;
  if ($[1] !== currentContent) {
    enqueue = content => {
      queueRef.current.push(content);
      if (!currentContent && !timerRef.current) {
        playNext();
      }
    };
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = () => queueRef.current.shift() || null;
      $[3] = t1;
    } else {
      t1 = $[3];
    }
    const dequeue = t1;
    const playNext = () => {
      const nextContent = dequeue();
      if (nextContent) {
        setCurrentContent(nextContent);
        scheduleNext();
      } else {
        stopPlaying();
      }
    };
    const scheduleNext = () => {
      timerRef.current = setTimeout(playNext, 10000);
    };
    const stopPlaying = () => {
      setCurrentContent(null);
      timerRef.current = null;
    };
    $[1] = currentContent;
    $[2] = enqueue;
  } else {
    enqueue = $[2];
  }
  let t1;
  if ($[4] !== enqueue) {
    t1 = () => {
      useChatMessageStore.getState().triggers.eventAnimCoin = payload => {
        const {
          contents
        } = payload.data.message.opt;
        enqueue(contents);
      };
      return () => {
        if (timerRef.current) {
          clearTimeout(timerRef.current);
        }
      };
    };
    $[4] = enqueue;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  useEffect(t1, t2);
  const t3 = currentContent?.json;
  const t4 = currentContent?.image;
  const t5 = currentContent?.width || 100;
  const t6 = currentContent?.height || 100;
  let t7;
  if ($[7] !== t3 || $[8] !== t4 || $[9] !== t5 || $[10] !== t6) {
    t7 = <div className="-translate-x-1/2 -translate-y-1/2 absolute top-1/2 left-1/2 flex w-full items-center justify-center"><BaseLottie src={t3} fallbackThumbnail={t4} width={t5} height={t6} loop={true} autoplay={true} /></div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
}
export default ChatEventLottie;